import { getHEXCodeFromString } from "main/src/modules/common/utils";
import type { FC } from "react";
import {
  Tag,
  TagColors,
  TagVariants,
  type TagSizes
} from "@certa/catalyst/components/Tag";
import { STANDARD_TAG_COLORS } from "@certa/catalyst/components/Tag/standardTagColors";
import { Ellipsis } from "@certa/catalyst/components/Typography";

type WorkflowStatusProps = {
  label?: string | number;
  customColorCode?: string | null;
  ellipsis?: number;
  onClick?: () => void;
  fullWidth?: boolean;
};

export type WorkflowStatusNewProps = WorkflowStatusProps & {
  size?: TagSizes;
};

export const WorkflowStatusNew: FC<WorkflowStatusNewProps> = ({
  label,
  ellipsis,
  customColorCode,
  onClick,
  size,
  fullWidth
}) => {
  let colorHexcode: string | undefined = undefined;
  let tagStandardColor: TagColors | undefined = TagColors.TEAL;

  if (customColorCode) {
    if (isStandardTagColor(customColorCode) && isTagColor(customColorCode)) {
      tagStandardColor = customColorCode;
      colorHexcode = undefined;
    } else {
      const hexCode = getHEXCodeFromString(customColorCode);
      if (hexCode) {
        colorHexcode = hexCode;
        tagStandardColor = undefined;
      }
    }
  }

  return (
    <Tag
      onClick={onClick}
      label={label?.toString() || ""}
      aria-label={`Workflow Status: ${label?.toString() || ""}`}
      variant={TagVariants.FILLED}
      backgroundColor={colorHexcode}
      color={tagStandardColor}
      size={size}
      maxWidth={
        fullWidth ? undefined : ellipsis ? ellipsis.toString() : "190px"
      }
      minWidth="0px"
      fullWidth={fullWidth}
    >
      <Ellipsis>{label?.toString() || ""}</Ellipsis>
    </Tag>
  );
};

const isTagColor = (color: string): color is TagColors => {
  return Object.values(TagColors).includes(color as TagColors);
};

export const isStandardTagColor = (
  color: string
): color is keyof typeof STANDARD_TAG_COLORS => {
  return Object.keys(STANDARD_TAG_COLORS).includes(color);
};
